<template>
  <div class="page">
    <h1 class="mt-0 mb-3">Заказы</h1>
    <OrdersTable />
    <OrderBlock class="mt-4" />
  </div>
</template>

<script>
import OrdersTable from '@/components/orders/OrdersTable';
import OrderBlock from '@/components/orders/OrderBlock';

export default {
  components: {
    OrdersTable,
    OrderBlock,
  },
};
</script>
